<template>
  <div>
    <van-action-sheet
        v-model="ZcShow"
        :actions="dataList"
        cancel-text="取消"
        close-on-click-action
        @close="close"
        @select="ZcSelect"
    />
  </div>
</template>

<script>
export default {
  name: "KeShi",
  data() {
    return {
      ZcShow: true,
      dataList: [],
    }
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      this.$http.get(this.$api.titleList).then(res => {
        let {code, data, message} = res
        if (code === 0) {
          this.dataList = data
        } else {
          this.$toast(message)
        }
      })
    },
    close() {
      this.$emit('change')
    },
    ZcSelect(e) {
      this.$emit('change', {value: e.name})
    },
  }
}
</script>

<style scoped>

</style>
